import React from 'react';

export interface ScoreNumberProps extends React.HTMLAttributes<HTMLDivElement>{
  score: number;
}

const ScoreNumber: React.FC<ScoreNumberProps> = ({ score }) => {
  return (
    <div className="score-number">
      <span className="score-number__text">
        {score}
      </span>
    </div>
  );
};

export default ScoreNumber;